"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pLimit_exports = {};
__export(pLimit_exports, {
  pLimit: () => pLimit
});
module.exports = __toCommonJS(pLimit_exports);
function pLimit(concurrency) {
  var queue = [];
  var active = 0;
  var next = function() {
    if (active < concurrency && queue.length > 0) {
      active++;
      var fn = queue.shift();
      fn();
    }
  };
  return function(fn) {
    return new Promise(function(resolve, reject) {
      queue.push(function() {
        fn().then(resolve).catch(reject).finally(function() {
          active--;
          next();
        });
      });
      next();
    });
  };
}
//# sourceMappingURL=pLimit.js.map
